import { useCallback, useMemo, useState } from "react";
import fieldInfos from "./Field_Info.json";
import { CriteriaUnitComb } from "./CriteriaUnit";
import label from "../labels/criteria_en.json";

export default function CriteriaEditor() {
  const [criteriaJson, setCriteriaJson] = useState("[]");
  const [criteriaJsonEsc, setCriteriaJsonEsc] = useState(JSON.stringify("[]"));
  const [showEscaped, setShowEscaped] = useState(false);
  const criteria = useMemo(() => {
    try {
      return JSON.parse(criteriaJson);
    } catch (error) {
      return null;
    }
  }, [criteriaJson]);

  const onCriteriaChange = useCallback(
    (event) => {
      if (!showEscaped) {
        setCriteriaJson(event.target.value);
        setCriteriaJsonEsc(JSON.stringify(event.target.value));
      } else {
        setCriteriaJsonEsc(event.target.value);
        try {
          setCriteriaJson(JSON.parse(event.target.value));
        } catch (error) {
          setCriteriaJson(null);
        }
      }
    },
    [setCriteriaJson, setCriteriaJsonEsc, showEscaped]
  );

  const notifyChange = () => {
    const criteriaJson = JSON.stringify(criteria, null, 2);
    setCriteriaJson(criteriaJson);
    setCriteriaJsonEsc(JSON.stringify(criteriaJson));
  };

  return (
    <div className="criteriaEditorOuter">
      <textarea
        className="form-control textArea"
        value={!showEscaped ? criteriaJson ?? "" : criteriaJsonEsc}
        onChange={onCriteriaChange}
      />
      <div>
        <input
          type="checkbox"
          id="show_escaped"
          checked={showEscaped}
          onChange={(event) => setShowEscaped(event.target.checked)}
        />
        <label htmlFor="show_escaped">{label.Show_Escaped}</label>
      </div>
      {criteria && (
        <CriteriaUnitComb
          type="And"
          childrenCriteria={criteria}
          guidelines={[]}
          notifyChange={notifyChange}
        />
      )}
      <datalist id="field-names">
        {fieldInfos.map((fieldInfo) => (
          <option key={fieldInfo.fieldName}>{fieldInfo.fieldName}</option>
        ))}
      </datalist>
    </div>
  );
}
